import React, { useState, useEffect } from 'react';
import { TabContents } from '../../2_Molecules/Tabs/TabContents';
import { handleRequest } from '../../../utils/httpRequest';
import Jelly from '../../2_Molecules/Jelly/Jelly';
import { getEndpointUrl } from '../../../utils/endPoints';
import { languageController } from '../../../controllers/language/languageController';
import { stripHTML } from '../../../utils/helpers';

interface Category {
  id: string;
  title: string;
}

interface Categories {
  [key: string]: Category;
}

interface Visual {
  static_content_base_path: string;
  jelly_path: string;
  jelly: string;
  jelly_hover: string;
}

interface CarlineCategory {
  id: string;
  title?: string;
}

interface Carline {
  title: string;
  categories: CarlineCategory[];
}

interface Financial {
  msrp: number;
}

interface Year {
  title: string;
}

interface ComingSoonData {
  top_copy?: string;
}

export interface ModelYear {
  id: string;
  year: Year;
  carline: Carline;
  visual: Visual;
  description: string;
  financial: Financial;
  previous_model: boolean;
  is_coming_soon: boolean;
  coming_soon_data?: ComingSoonData;
}

interface VehiclesData {
  categories: Categories;
  model_years: ModelYear[];
}

interface TabData {
  id: string;
  tabTitle: string;
  tabContent: JSX.Element[];
}

interface SelectVehicleProps {
  onSelectVehicle: (vehicle: ModelYear) => void;
  preDefinedModelId?: string;
}

const SelectVehicle: React.FC<SelectVehicleProps> = ({
  onSelectVehicle,
  preDefinedModelId
}) => {
  const [vehicles, setVehicles] = useState<VehiclesData | null>(null);

  useEffect(() => {
    const loadVehicles = async () => {
      try {
        const res = await handleRequest('get', getEndpointUrl('model-years') || '');
        if (res.status === 200 && res.data) {
          setVehicles(res.data);
        } else {
          console.log('Error: ', res.message);
        }
      } catch (err) {
        console.log('Error: ', err);
      }
    };
    loadVehicles();
  }, []);

  const getPreviousModelVehicles = (vehicles: ModelYear[]): ModelYear[] => {
    return vehicles.filter(vehicle => vehicle.previous_model && !vehicle.is_coming_soon);
  };

  const generateImageSrc = (vehicleData: ModelYear, isHover: boolean = false): string => {
    if (!vehicleData || !vehicleData.visual) return '';
    const { static_content_base_path, jelly_path, jelly, jelly_hover } = vehicleData.visual;
    return static_content_base_path + jelly_path + (isHover ? jelly_hover : jelly);
  };

  const createTabs = (vehicles: VehiclesData): (TabData | string)[] => {
    if (!vehicles) return [];

    const { categories, model_years } = vehicles;
    const nonPrevModelYears = model_years.filter(model => !model.previous_model);

    return Object.keys(categories).map(key => {
      let futureVehicles: ModelYear[] = [];
      const vehiclesOfCategoty = nonPrevModelYears.filter(model => {
        const isMatched = model.carline.categories.some(category => category.id === categories[key].id);
        if (!isMatched) return false;
        if (model.is_coming_soon) {
          futureVehicles = [...futureVehicles, model];
          return false;
        }
        return true;
      });

      if (!vehiclesOfCategoty.length) return '';

      return ({
        id: categories[key].title,
        tabTitle: categories[key].title,
        tabContent: [...vehiclesOfCategoty, ...futureVehicles].map(vehicleData => {
          return (
            <Jelly
              key={vehicleData.id}
              carName={vehicleData.carline.title}
              carModel={stripHTML(vehicleData.description)}
              carPrice={vehicleData.financial.msrp}
              onClick={() => {
                if (vehicleData.is_coming_soon) return;
                onSelectVehicle(vehicleData);
              }}
              topLabel={vehicleData.coming_soon_data?.top_copy}
              isInactive={vehicleData.is_coming_soon}
              carImageSrc={generateImageSrc(vehicleData)}
              carImageHoverSrc={generateImageSrc(vehicleData, true)}
              isSelected={(vehicleData.id === preDefinedModelId)}
            />
          );
        })
      });
    });
  };

  return (
    <div className="mz-select-vehicle">
      {
        vehicles && (
          <TabContents
            dataTabs={[
              ...createTabs(vehicles).filter((tab): tab is TabData => tab !== '')/*,
              {
                id: 'previous',
                tabTitle: languageController.getCopy('global', 'previous'),
                tabContent: getPreviousModelVehicles(vehicles.model_years).map(vehicleData => {
                  return (
                    <Jelly
                      key={vehicleData.id}
                      carName={vehicleData.year.title + ' ' + vehicleData.carline.title}
                      carModel={stripHTML(vehicleData.description)}
                      carPrice={vehicleData.financial.msrp}
                      onClick={() => onSelectVehicle(vehicleData)}
                      isSelected={(vehicleData.id === preDefinedModelId)}
                      carImageSrc={generateImageSrc(vehicleData)}
                      carImageHoverSrc={generateImageSrc(vehicleData, true)}                      
                    />
                  )
                })
              }*/
            ]}
            defaultTab={vehicles.categories[Object.keys(vehicles.categories)[0]].title}
          />
        )
      }
    </div>
  );
}

export default SelectVehicle;
